export function toFileArray(files) {
    if (Array.isArray(files)) {
        return files.filter(Boolean);
    }
    if (files && typeof files.length === 'number') {
        return Array.from(files).filter(Boolean);
    }
    return files ? [files] : [];
}

export function mergeUploadResults(results, initial = { files: [] }) {
    return (Array.isArray(results) ? results : []).reduce((acc, result) => {
        Object.keys(result || {}).forEach(key => {
            if (Array.isArray(result[key])) {
                acc[key] = (Array.isArray(acc[key]) ? acc[key] : []).concat(result[key]);
            } else {
                acc[key] = result[key];
            }
        });
        return acc;
    }, initial);
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export async function uploadFileWithRetry(uploadFile, file, options = {}) {
    const maxAttempts = Number(options.maxAttempts) || 3;
    const baseDelay = Number(options.baseDelay) || 500;

    for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
        try {
            return await uploadFile(file, attempt);
        } catch (error) {
            if (attempt === maxAttempts || (typeof options.shouldRetry === 'function' && !options.shouldRetry(error))) {
                throw error;
            }
            await sleep(baseDelay * Math.pow(2, attempt - 1));
            if (typeof options.shouldRetry === 'function' && !options.shouldRetry(error)) {
                throw error;
            }
        }
    }
    return null;
}

export async function uploadFilesSequential(files, uploadFile, options = {}) {
    const queue = toFileArray(files);
    const results = [];

    for (let index = 0; index < queue.length; index += 1) {
        const file = queue[index];
        if (typeof options.onFileStart === 'function') {
            options.onFileStart(file, index, queue);
        }
        const result = await uploadFileWithRetry(
            (currentFile, attempt) => uploadFile(currentFile, index, queue, attempt),
            file,
            options
        );
        results.push(result);
    }

    return results;
}

export function createSingleFileFormData(fieldName, file, extraFields = {}, fileName = null) {
    const formData = new FormData();

    Object.keys(extraFields || {}).forEach(key => {
        const value = extraFields[key];
        if (value !== undefined && value !== null) {
            formData.append(key, value);
        }
    });

    if (fileName) {
        formData.append(fieldName, file, fileName);
    } else {
        formData.append(fieldName, file);
    }

    return formData;
}
